module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av222-2839ebd05c9f9d9ce43cbd78c1f3752e.jpg";